/* ===== Anadita Luxe — sticky add to cart ===== */
(function () {
  'use strict';
  var bar = document.querySelector('[data-sticky-atc]');
  var mainBtn = document.querySelector('[data-atc]');
  var form = document.querySelector('[data-product-form]');
  if (!bar || !mainBtn) return;
  if ('IntersectionObserver' in window) {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        var visible = !e.isIntersecting && e.boundingClientRect.top < 0;
        bar.classList.toggle('is-visible', visible);
        // When the sticky ATC is showing, yield the bottom edge to it (hide bottom nav).
        document.body.classList.toggle('sticky-atc-on', visible);
      });
    }, { threshold: 0 });
    io.observe(mainBtn);
  }
  var stickyAdd = bar.querySelector('[data-sticky-add]');
  if (stickyAdd) stickyAdd.addEventListener('click', function () {
    if (form && typeof form.requestSubmit === 'function') form.requestSubmit();
    else if (form) form.submit();
    else mainBtn.click();
  });
})();
